import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule} from '@angular/forms';
import {SaleTaxComponent} from './saletax.component';
import {CalendarModule, CheckboxModule} from 'primeng/primeng';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { StepsModule } from 'primeng/steps';
import {UnGroupedSaleTaxListComponent} from "./ungrouped-list/ungrouped-list.component";
import {GroupedSaleTaxListComponent} from "./grouped-list/grouped-list.component";
import {GroupedSaleTaxListDetailComponent} from "./grouped-list-detail/grouped-list-detail.component";

@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule,
    CalendarModule,
    CheckboxModule,
    NgbModule,
    StepsModule
  ],
  declarations: [SaleTaxComponent, 
    UnGroupedSaleTaxListComponent, 
    GroupedSaleTaxListComponent, 
    GroupedSaleTaxListDetailComponent
  ]
})
export class SaleTaxModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/saletax/saletax.module.ts